






















import { Size } from '@front-app/components/constants';
import { defineComponent } from '@vue/composition-api';
import { HighlightsButtonStyle, UnfilledHighlightsButtonMeta } from '../../model';
import Placeholder from '../BasePlaceholder.vue';
import ButtonRender from './ButtonRender.vue';

const defaultMeta: UnfilledHighlightsButtonMeta = {
	mainText: 'Button',
	action: null,
	style: HighlightsButtonStyle.FILLED,
	href: '',
	size: Size.SMALL,
};

export default defineComponent({
	components: { Placeholder, ButtonRender },
	setup() {
		return {
			defaultMeta,
		};
	},
});
